import createVueComponent from '../createVueComponent';

const MoveUpRight = createVueComponent('MoveUpRightIcon', [
  ['path', { d: 'M13 5H19V11', key: '1n1gyv' }],
  ['path', { d: 'M19 5L5 19', key: '72u4yj' }],
]);

export default MoveUpRight;
